<template>
  <div id="main">
    <div id="header">
      <span class="headertext">{{ $t.error_pg_title }}</span>
    </div>
    <div id="content">
      <p>{{ $t.error_pg_body }}</p>
    </div>
  </div>
</template>

<script setup>
import { inject, onMounted } from "vue";

let $t = inject("$t") || {};
let loggingService = inject("loggingService", {});

const PAGE_TYPE = "Error";

onMounted(() => {
  loggingService.logEndPageLoad(PAGE_TYPE)
});
</script>

<style scoped></style>
